import styled from 'styled-components'

export const GlobalModalContent = styled.div`
    padding: 1em;
    flex: 1;
`
